/** @format */

import ChoosePlanFarming from "../choosePlanFarming";
import Countdown from "react-countdown";
import style from "./index.module.scss";
import iconUSDT from "../../../assets/roll/modals/USDT.png";
import { useEffect, useState } from "react";
import { ModalRewardUSDTType } from "../../../lib/types/modal";
import ButtonClaim from "../../buttons/buttonClaim";

const ModalRewardUSDT = ({
	onClickButtonQuickUSDT,
	onClosePopup,
	timeCountDown,
	onClickWithDraw,
}: ModalRewardUSDTType) => {
	const [isComplete, setComplete] = useState(false);
	return (
		<ChoosePlanFarming
			onClose={onClosePopup}
			iconPopup={iconUSDT}
			customStyle={{
				width: "230px",
				height: "auto",
				top: "-30%",
			}}
		>
			<div className={style.popup__usdt_wrapper}>
				<h2 className={style.popup__usdt_title}>You won $5 USDT!</h2>
				<p className={style.popup__usdt_description}>
					Security check takes 48 hours. <br />
					If approved, you can withdraw the $5 balance in APT <br />
				</p>
			</div>
		</ChoosePlanFarming>
	);
};

export default ModalRewardUSDT;
